import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';

import Axios from 'axios';
import { useDispatch } from 'react-redux';
import styles from './styles';
import formFields from './BuilderProfilePersonalForm/formFields';
import BuilderProfilePersonalForm from './BuilderProfilePersonalForm';
import {
  preparePhoneNumberForFrontend,
  preparePhoneNumberForBackend,
  formatDateForBackend,
} from '../../utilities/helpers';
import { updateBuilderPersonalInfo } from './updateBuilderPersonal';
import {
  API_KEY_JOBS,
  API_SUCCESS_MESSAGES,
  BUILDER_DEACTIVATE_REASONS,
  GET_BUSINESS_INFO,
} from '../../constants';
import { createActivity, updateBuilderBusiness } from '../../apis';
import { apiCallSuccess } from '../../store/actions/notification';

const propTypes = {
  classes: PropTypes.shape({
    heading: PropTypes.string,
    username: PropTypes.string,
    cardRoot: PropTypes.string,
  }).isRequired,
  userAttributes: PropTypes.shape({
    'custom:buildingLicNo': PropTypes.string,
    'custom:buildingLicExp': PropTypes.string,
    'custom:personalPhone': PropTypes.string,
    'custom:mobileNumber': PropTypes.string,
    priorityListing: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
    username: PropTypes.string,
    deactivate: PropTypes.bool,
    reason: PropTypes.string,
  }).isRequired,
  setBuilder: PropTypes.func,
  dispatchApiCallFailed: PropTypes.func,
  dispatchApiCallSuccess: PropTypes.func,
};

export const BuilderProfilePersonalContainer = props => {
  const {
    classes,
    userAttributes,
    setBuilder,
    dispatchApiCallFailed,
    dispatchApiCallSuccess,
  } = props;
  const dispatch = useDispatch();
  const [editing, setEditing] = useState(false);
  const [initialDate, setInitialDate] = useState('');
  const [previousValues, setPreviousValues] = useState({});
  const [showInSearch, setShowInSearch] = useState(null);
  const [builderDetailsResponse, setBuilderDetailsResponse] = useState({});
  const [
    builderShowInSearchUpdateLoading,
    setBuilderShowInSearchUpdateLoading,
  ] = useState(false);

  console.log({ builderDetailsResponse, showInSearch });
  useEffect(() => {
    const initialDateFormat = moment(
      userAttributes['custom:buildingLicExp'],
    ).format('DD-MM-YYYY');
    setInitialDate(initialDateFormat);
    // console.log('userAttrs', { userAttributes, initialDate });
    setPreviousValues(getInitialFormValues);
  }, [userAttributes]);

  useEffect(() => {
    setPreviousValues(values => ({
      ...values,
      showInSearch: builderDetailsResponse.showInSearch,
    }));
  }, [builderDetailsResponse]);

  const [expiryDate, setExpiryDate] = useState('');

  const getInitialFormValues = () => {
    const initialValues = {};

    initialValues.businessNumber = userAttributes.username;
    initialValues.showInSearch = builderDetailsResponse.showInSearch;
    formFields.forEach(field => {
      if (userAttributes[field.name] != null) {
        if (field.name === 'custom:personalPhone') {
          initialValues['custom:personalPhone'] = preparePhoneNumberForFrontend(
            userAttributes['custom:personalPhone'],
          );
        } else if (
          field.name === 'custom:mobileNumber' &&
          userAttributes['custom:mobileNumber']
        ) {
          initialValues['custom:mobileNumber'] = preparePhoneNumberForFrontend(
            userAttributes['custom:mobileNumber'],
          );
        } else if (field.name === 'custom:buildingLicExp') {
          if (userAttributes['custom:buildingLicExp']) {
            initialValues['custom:buildingLicExp'] = initialDate;
          } else {
            initialValues['custom:buildingLicExp'] = moment(new Date()).format(
              'YYYY-MM-DD',
            );
          }
        } else if (field.name === 'priorityListing') {
          initialValues.priorityListing = userAttributes.priorityListing;
        } else {
          initialValues[field.name] = userAttributes[field.name];
        }
        initialValues.deactivate = userAttributes.deactivate;
        const reason = BUILDER_DEACTIVATE_REASONS.find(
          obj => obj.value === userAttributes.reason,
        );
        if (reason) {
          initialValues.reason = userAttributes.reason;
        } else if (userAttributes.reason) {
          initialValues.reason = 'Others';
          initialValues.other_reason = userAttributes.reason;
        }
      }
    });

    return initialValues;
  };

  const getBusinessInfo = async businessId => {
    const token = localStorage.getItem('accessToken');
    try {
      const response = await Axios({
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': `${API_KEY_JOBS}`,
          Authorization: `Bearer ${token}`,
        },
        url: `${GET_BUSINESS_INFO}/${businessId}/businesses`,
        validateStatus(status) {
          return status === 200; // default
        },
      });
      if (response.data.businesses.length)
        // console.log(response.data, 'builder get info');
        setBuilderDetailsResponse(response.data.businesses[0]);
      setShowInSearch(response.data.businesses[0].showInSearch);
      // setBusiness(
      //   mapBusinessResponseToBusinessAttributes(response.data.businesses[0]),
      // );
      return response.data;
    } catch (err) {
      throw err;
    }
  };
  React.useEffect(() => {
    getBusinessInfo(userAttributes.username);
  }, [userAttributes.username]);

  // console.log(userAttributes['custom:buildingLicExp'], 'userAttributes');

  const updateBuilderShowInSearch = async (builderId, data) => {
    setBuilderShowInSearchUpdateLoading(true);
    updateBuilderBusiness(builderId, data)
      .then(async res => {
        setBuilderDetailsResponse(res.data.business);
        // console.log({ res });
        const createActivityResponse = await createActivity(
          builderId,
          localStorage.getItem('username'),
          'Show in search updated',
        );
        console.log(createActivityResponse);
        setBuilderShowInSearchUpdateLoading(false);
      })

      .catch(err => {
        setBuilderShowInSearchUpdateLoading(false);
        console.log({ err });
      });
  };

  const handleFormSubmitted = values => {
    // console.log({ ...values, expiryDate });
    // return;
    // update email which is used for user explicitly

    if (values.other_reason) {
      values.reason = values.other_reason;
    }
    delete values.other_reason;
    const [y, m, d] = expiryDate.split('-');

    const updatedValues = {
      ...values,
      email: values.email,
      showInSearch,
      'custom:buildingLicExp': `${d}-${m}-${y}`,
    };

    // Add country code to primary phone number
    updatedValues['custom:personalPhone'] = preparePhoneNumberForBackend(
      updatedValues['custom:personalPhone'],
    );

    // This is an optional field, check before running method
    updatedValues['custom:mobileNumber'] = updatedValues['custom:mobileNumber']
      ? preparePhoneNumberForBackend(updatedValues['custom:mobileNumber'])
      : undefined;

    updatedValues['custom:buildingLicExp'] = updatedValues[
      'custom:buildingLicExp'
    ]
      ? formatDateForBackend(updatedValues['custom:buildingLicExp'])
      : undefined;

    // Previous Values
    // Add country code to primary phone number
    previousValues['custom:personalPhone'] = preparePhoneNumberForBackend(
      previousValues['custom:personalPhone'],
    );

    // This is an optional field, check before running method
    previousValues['custom:mobileNumber'] = previousValues[
      'custom:mobileNumber'
    ]
      ? preparePhoneNumberForBackend(previousValues['custom:mobileNumber'])
      : undefined;

    previousValues['custom:buildingLicExp'] =
      userAttributes['custom:buildingLicExp'];

    // console.log({
    //   values,
    //   updatedValues,
    //   username: userAttributes.username,
    //   previousValues,
    // });
    if (updatedValues.showInSearch !== previousValues.showInSearch) {
      updateBuilderShowInSearch(userAttributes.username, { showInSearch });
    }

    delete previousValues.showInSearch;
    delete updatedValues.showInSearch;
    updateBuilderPersonalInfo(
      updatedValues,
      userAttributes.username,
      previousValues,
    )
      .then(() => {
        setEditing(false);
        dispatchApiCallSuccess();
        dispatch(apiCallSuccess(API_SUCCESS_MESSAGES.PROFILE_UPDATED));
        updatedValues.deactivate = values.deactivate;
        const reason = BUILDER_DEACTIVATE_REASONS.find(
          obj => obj.value === values.reason,
        );
        if (reason) {
          updatedValues.reason = values.reason;
        } else if (values.reason) {
          updatedValues.reason = values.reason;
        }
        return setBuilder(Object.assign({}, userAttributes, updatedValues));
      })
      .catch(() => {
        dispatchApiCallFailed();
      });
  };

  useEffect(() => {
    if (userAttributes['custom:buildingLicExp']) {
      const [y, m, d] = userAttributes['custom:buildingLicExp'].split('-');
      setExpiryDate(`${y}-${m}-${d}`);
    } else {
      const [y, m, d] = moment(new Date()).format('YYYY-MM-DD');
      setExpiryDate(`${y}-${m}-${d}`);
    }
  }, [userAttributes]);

  console.log('new console - 1');
  return (
    <Card className={classes.cardRoot}>
      <CardContent>
        <h2 className={classes.heading}>{userAttributes.name}</h2>
        <BuilderProfilePersonalForm
          initialValues={getInitialFormValues()}
          onSubmit={values => handleFormSubmitted(values)}
          enableReinitialize
          enableEditing={editing}
          setEditing={setEditing}
          showInSearch={showInSearch}
          setShowInSearch={setShowInSearch}
          expiryDate={expiryDate}
          setExpiryDate={setExpiryDate}
          isUpdatingShowInSearch={builderShowInSearchUpdateLoading}
        />
      </CardContent>
    </Card>
  );
};

BuilderProfilePersonalContainer.propTypes = propTypes;

export default withStyles(styles)(BuilderProfilePersonalContainer);
